function syncTransparentHeader() {
  const headerSection = document.querySelector('.header-section');
  if (!headerSection) return;

  const allowTransparent = !!document.querySelector('.shopify-section:first-child [allow-transparent-header]');
  headerSection.classList.toggle('header-transparent', allowTransparent);
}

document.addEventListener('DOMContentLoaded', syncTransparentHeader);

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', syncTransparentHeader);
  document.addEventListener('shopify:section:unload', syncTransparentHeader);
  document.addEventListener('shopify:section:reorder', syncTransparentHeader);
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href == '#') return;
      const target = document.querySelector(href);
      
      if (target) {
        // For login/recover password links, set hash to trigger :target CSS
        if (href === '#Recover' || href === '#Login' || href === '#login') {
          e.preventDefault();
          // Normalize to match the actual ID (Login with capital L)
          const normalizedHash = href === '#login' ? '#Login' : href;
          window.location.hash = normalizedHash;
          // Small delay to ensure hash is set before scrolling
          setTimeout(() => {
            const normalizedTarget = document.querySelector(normalizedHash);
            if (normalizedTarget) {
              normalizedTarget.scrollIntoView({ behavior: 'smooth' });
            }
          }, 10);
        } else {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });
});

/* Search page: show matching collections above the search results */
class SearchCollections extends HTMLElement {
  connectedCallback() {
    const terms = this.dataset.terms;
    if (!terms) return;

    // Same-origin URL: theme.routes.shop_url is the myshopify domain under `shopify theme dev` (CORS)
    const url = new URL(theme.routes.predictive_search_url, window.location.origin);
    url.searchParams.set('q', terms);
    url.searchParams.set('resources[type]', 'collection');
    url.searchParams.set('resources[limit]', 10);
    url.searchParams.set('section_id', 'search-collections');

    fetch(url)
      .then(response => response.ok ? response.text() : '')
      .then(text => {
        const content = new DOMParser().parseFromString(text, 'text/html').querySelector('.search-collections__inner');
        if (!content) return;

        this.replaceChildren(content);
        this.hidden = false;
      })
      .catch(() => {});
  }
}

if (!customElements.get('search-collections')) {
  customElements.define('search-collections', SearchCollections);
}
